import { inject, Input, Pipe, PipeTransform } from '@angular/core';
import { UserContext, config, MemberQuery } from '@fgb/core';

@Pipe({ name: 'contentImage' })
export class ContentImagePipe implements PipeTransform {
  @Input() loyaltyType: 'marketplace' | 'auction' | 'lotto' | 'wallet' | 'walletRedeemed' | 'badge';
  private memberQuery = inject(MemberQuery);

  transform(value: any, variantId: any, loyaltyType?: string) {
    if (!value) {
      if (!loyaltyType) {
        return `${config.contentUrl}/images/noimage.png`;
      } else {
        switch (loyaltyType) {
          case 'marketplace': {
            return 'assets/images/placeholders/marketplace-item.png';
          }
          case 'auction': {
            return 'assets/images/placeholders/auction-item.png';
          }
          case 'lotto': {
            return 'assets/images/placeholders/lotto-item.png';
          }
          case 'wallet': {
            return 'assets/images/placeholders/marketplace-item.png';
          }
          case 'badge': {
            return 'assets/images/placeholders/badge-item.png';
          }
          default: {
            return 'assets/images/placeholders/marketplace-item.svg';
          }
        }
      }
    } else {
      if (value.includes('http')) {
        return value; // If the value is already a full URL, return it as is
      }

      let currentUser =
        this.memberQuery.getValue().user || ({ clubId: config.defaultClubId, lcid: config.defaultLcid } as UserContext);

      const imageName = value.substring(0, value.indexOf('.'));
      const fileExtension = value.substring(value.indexOf('.'));

      return `${config.contentUrl}/image/${imageName}__${currentUser.clubId}_${variantId}_${currentUser.lcid}${fileExtension}`;
    }
  }
}
